import { render, staticRenderFns } from "./EventFieldSetting.vue?vue&type=template&id=f27211d2"
import script from "./EventFieldSetting.vue?vue&type=script&lang=js"
export * from "./EventFieldSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports